import { render, staticRenderFns } from "./RgpMenuBtns.vue?vue&type=template&id=0fdee147&scoped=true&"
import script from "./RgpMenuBtns.vue?vue&type=script&lang=js&"
export * from "./RgpMenuBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fdee147",
  null
  
)

export default component.exports